import { ICellRendererParams } from "ag-grid-community";

export class AgentStateSummaryData {
    formattedDuration: string;
    percentage: number; // decimal form need to * 100 and add percent sign
    // durationHours: number; // they used to want
    duration: number;
    agentStateName: string;
    agentStateCategory: string;
};

export enum EStateName {
    Available = "Available", // green
    Ended = "Ended", // gray
    Unavailable = "Unavailable", // red
    AwaitingContacts = "Awaiting Contacts", // orange
    WorkingContacts = "Working Contacts", // purple
    Created = "Created" // blue
}

export interface AgentStateSummaryCellParams extends ICellRendererParams {
    getLargerDurationExists(): boolean;
}
